import { render, staticRenderFns } from "./Overdue.vue?vue&type=template&id=41825308&scoped=true&"
import script from "./Overdue.vue?vue&type=script&lang=js&"
export * from "./Overdue.vue?vue&type=script&lang=js&"
import style0 from "./Overdue.vue?vue&type=style&index=0&id=41825308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41825308",
  null
  
)

export default component.exports